module.exports = __webpack_public_path__ + "static/c1-5c10aab3f9cbc0c034851167ebbccfef.jpg";